import { request } from "../utils/request";
import { config } from "../utils/constants";

export const getExamResultsByUserEmail = async (email) => {
    const data = await request({
      url: `${config.examResultEndPoint}scopes/guest?fields=date%2Cemail%2CtestName%2Cresult&filter=email%20eq%20%27${email}%27%20and%20result%20eq%20%27pass%27&pageSize=0`,
      method: "get",
    });
    return data.items
}